import { HOUSING_TYPE_LABELS } from "../constants/housing";
import { CLIENT_TYPE_LABELS, WHICHENSURE_TYPE_LABELS } from "../constants/personaldata";

class Opportunity {
    constructor({
        names = null,
        surname = null,
        email = null,
        cellphone = null,
        documentNumber = null,
        channel = null,
        from = null,
        requestId = null,
        clientType = null,
        whichEnsure = null,
        housingType = null,
        contactConsent = false,
    } = {}) {
        this.nombre = names;
        this.apellido = surname;
        this.email = email;
        this.celular = cellphone;
        this.dni = documentNumber;
        this.canal = channel || "Ecommerce";
        this.producto = "Hogar Online";
        this.from = from;
        this.idEcommerce = requestId;
        this.quien = CLIENT_TYPE_LABELS[clientType] || "";
        this.que = WHICHENSURE_TYPE_LABELS[whichEnsure] || "";
        this.tipo = HOUSING_TYPE_LABELS[housingType] || "";
        this.consentimiento = contactConsent ? "Sí" : "No";
    }
}

export default Opportunity;
